import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { bolsas_media, bolsas_rede, bolsas_rede_novos, bolsas_rede_renovados } from "../../services/api";

const Bolsas_media = (props) => {

    const [data2, setData2] = useState([]);
    const [dataRede, setDataRede] = useState([]);
    const [dataRedeNonos, setDataRedeNovos] = useState([]);
    const [dataRedeRenovados, setDataRedeRenovados] = useState([]);

    let data_inicio = props.di;
    let data_fim = props.df;

    // const unidades = ['', 'BR', 'MD', 'SC', 'CD', 'TQ', 'NP', '', '', 'SP', 'BT', 'CG', 'CE', 'MG', 'MC', 'IG', 'FG', 'RB']
    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio']

    const fetchData = async () => {
        try {
            const response = await bolsas_media(data_inicio, data_fim);
            setData2(response);
            const response2 = await bolsas_rede();
            setDataRede(response2.data[0]);
            const response3 = await bolsas_rede_novos();
            setDataRedeNovos(response3.data[0]);
            const response4 = await bolsas_rede_renovados();
            setDataRedeRenovados(response4.data[0]);

        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);

    const options = {
        // width: 700, height: 230,
        redFrom: 33, redTo: 66,
        yellowFrom: 24, yellowTo: 33,
        minorTicks: 5,
        max: 66,
        min: 0
    };

    let chartDataBol = [];


    const options2 = {
        allowHtml: true,

    };
    const formatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                suffix: "%",
            },
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 55, "white", "red"],
                [55, 100, "white", "darkred"],
            ],
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 55, "white", "red"],
                [55, 100, "white", "darkred"],
            ],
        },
    ];
    const formatters2 = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 1,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 55, "white", "red"],
                [55, 100, "white", "darkred"],
            ],
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                suffix: "%",
            },
        },
        {
            type: "ColorFormat",
            column: 2,
            ranges: [
                [0, 25, "white", "green"],
                [25, 40, "white", "orange"],
                [40, 55, "white", "red"],
                [55, 100, "white", "darkred"],
            ],
        },
    ];


    if (typeof data2 !== 'undefined') {

        chartDataBol = data2.map((item, index) => {
            const row = [unidades[parseInt(item.sec)]];
            row.push(parseFloat(item.bolsa_media_sem_100) || 0);
            row.push(parseFloat(item.bolsa_media) || 0);
            return row;
        });
    }
    chartDataBol.sort();
    chartDataBol.unshift(["Label", "Value", "Value"]);

    let chartDataTable = chartDataBol;

    chartDataTable.shift();
    chartDataTable.unshift(["Unindade", "B. Média s100", "Bolsa Média"]);

    let chartDataRede = [];

    if ((typeof dataRede !== 'undefined') && (typeof dataRedeNonos !== 'undefined') && (typeof dataRedeRenovados !== 'undefined')) {
        chartDataRede.push(['SMREDE', 'BM S100', 'B. Média']);
        chartDataRede.push(['Total', parseFloat(dataRede.bolsa_media_dif_100), parseFloat(dataRede.bolsa_media)]);
        chartDataRede.push(['Novos', parseFloat(dataRedeNonos.bolsa_media_dif_100), parseFloat(dataRedeNonos.bolsa_media)]);
        chartDataRede.push(['Renovados', parseFloat(dataRedeRenovados.bolsa_media_dif_100), parseFloat(dataRedeRenovados.bolsa_media)]);
    }


    return (
        <div className="bolsas">
            {/* <Chart
                chartType="Gauge"
                width="100%"
                height="230px"
                data={chartDataBol}
                options={options}
            /> */}
            <center>
                <Chart
                    chartType="Table"
                    version="current"
                    width="100%"
                    height="100%"
                    data={chartDataBol}
                    options={options2}
                    formatters={formatters}
                />
                <br />
                <b>
                    Bolsa Média da Rede
                </b>
                <Chart
                    chartType="Table"
                    version="current"
                    width="100%"
                    height="100%"
                    data={chartDataRede}
                    options={options2}
                    formatters={formatters2}
                />

            </center>

        </div>

    );
};
export default Bolsas_media;